import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import CarrierServiceSetting from '@/plugins/sdk/resources/Account/CarrierServiceSetting'
import ServiceType from '../Commercial/ServiceType'

export default class extends Resource {
  static name = 'carrier_service'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      code: new STRING(),
      con: new STRING(),
      service_label: new STRING(),
      edi: new STRING(),
      chainit: new STRING(),
      type: new STRING(),
      items_min: new STRING(),
      items_max: new STRING(),
      weight_min: new STRING(),
      weight_max: new STRING(),
      volume_min: new STRING(),
      volume_max: new STRING(),
      default_cubic: new STRING(),
      warn_chweight: new STRING(),
      warn_length: new STRING(),
      allow_dg: new BOOLEAN(),
      config_itm_prefix_req: new BOOLEAN(),
      config_itm_prefix_def: new STRING(),
      config_itm_min_def: new STRING(),
      config_itm_max_def: new STRING(),
      reference: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      carrier: new ITEM(Carrier),
      account_carrier_service_settings: new COLLECTION(CarrierServiceSetting),
      hide_from_pickups: new BOOLEAN(),
      item_rules: new STRING(),
      service_type: new ITEM(ServiceType),
      service_supports_pobox: new BOOLEAN(),
      service_supports_tailgate: new BOOLEAN(),
      service_supports_timeslot: new BOOLEAN(),
      service_supports_moffett: new BOOLEAN(),
      service_supports_handunload: new BOOLEAN(),
      service_supports_twomanlift: new BOOLEAN(),
      service_supports_saturdaydelivery: new BOOLEAN(),
      service_supports_bunnings: new BOOLEAN()
    }
  }
}
